import React from "react";
import ".././popup.common.css";
import CustomModal from "../../Modal/CustomModal";
import BorderedButton from "../../Buttons/BorderedButton";
import PrimaryButton from "../../Buttons/PrimaryButton";

const MembershipNoPasswordPopup = ({
	onClose,
	onUseWithoutPassword,
	isSubmitting = false,
}) => {
	return (
		<CustomModal show={true} onHide={onClose} hideCloseButton={true}>
			<div className="popup membershipNoPasswordPopup">
				<div className="header">
					<h2>Member account has no password configured</h2>
				</div>
				<div className="body">
					<p>
						Please note that physical verification must be performed to confirm the
						customer&apos;s identity.
					</p>
				</div>
				<div className="footer">
					<BorderedButton text="Cancel" onClick={onClose} />
					<PrimaryButton
						text="Use without Password"
						onClick={onUseWithoutPassword}
						disabled={isSubmitting}
					/>
				</div>
			</div>
		</CustomModal>
	);
};

export default MembershipNoPasswordPopup;
